export default __webpack_public_path__ + "static/media/1.67ec7e5b.jpg";